import { v4 as uuidv4 } from 'uuid';
import cogoToast from 'cogo-toast';
import i18n from '../../i18n';
const { createSlice } = require('@reduxjs/toolkit');

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        cartItems: [],
        couponData: null,
        pendingCoupon: null
    },
    reducers: {
        addToCart(state, action) {
            const product = action.payload;

            // Variation kontrolü: chain_colors, chain_types veya available_sizes varsa variation var demektir
            const hasVariation = (product.chain_colors && product.chain_colors.length > 0) ||
                (product.chain_types && product.chain_types.length > 0) ||
                (product.available_sizes && product.available_sizes.length > 0);

            if (!hasVariation) {
                // Variation yoksa sadece id'ye göre kontrol et
                const cartItem = state.cartItems.find(item => item.id === product.id);
                if (!cartItem) {
                    state.cartItems.push({
                        ...product,
                        quantity: product.quantity ? product.quantity : 1,
                        cartItemId: uuidv4()
                    });
                } else {
                    state.cartItems = state.cartItems.map(item => {
                        if (item.cartItemId === cartItem.cartItemId) {
                            return {
                                ...item,
                                quantity: product.quantity ? item.quantity + product.quantity : item.quantity + 1
                            }
                        }
                        return item;
                    })
                }
            } else {
                // Variation varsa: id, renk, tip ve beden kombinasyonuna göre kontrol et
                const cartItem = state.cartItems.find(
                    item => {
                        // Önce id kontrolü
                        if (item.id !== product.id) return false;

                        // Renk kontrolü (null, undefined veya boş string kontrolü)
                        const productColor = product.selectedProductColor || null;
                        const itemColor = item.selectedProductColor || null;
                        if (productColor !== itemColor) return false;

                        // Zincir tipi kontrolü
                        const productChainType = product.selectedChainType || null;
                        const itemChainType = item.selectedChainType || null;
                        if (productChainType !== itemChainType) return false;

                        // Beden kontrolü
                        const productSize = product.selectedProductSize || null;
                        const itemSize = item.selectedProductSize || null;
                        if (productSize !== itemSize) return false;

                        // Teknoloji kontrolü
                        const productTechnology = product.selectedTechnology || null;
                        const itemTechnology = item.selectedTechnology || null;
                        if (productTechnology !== itemTechnology) return false;

                        // Tüm kontroller geçti, aynı kombinasyon
                        return true;
                    }
                );

                if (!cartItem) {
                    // Aynı kombinasyon yoksa yeni item ekle
                    state.cartItems.push({
                        ...product,
                        quantity: product.quantity ? product.quantity : 1,
                        cartItemId: uuidv4()
                    });
                } else {
                    // Aynı kombinasyon varsa miktarı artır
                    state.cartItems = state.cartItems.map(item => {
                        if (item.cartItemId === cartItem.cartItemId) {
                            return {
                                ...item,
                                quantity: product.quantity ? item.quantity + product.quantity : item.quantity + 1,
                                selectedProductColor: product.selectedProductColor || item.selectedProductColor,
                                selectedChainType: product.selectedChainType || item.selectedChainType,
                                selectedProductSize: product.selectedProductSize || item.selectedProductSize
                            }
                        }
                        return item;
                    });
                }
            }

            // Ürün eklendiğinde kuponu temizle (fiyatların güncellenmesi için)
            if (state.couponData) {
                state.couponData = null;
            }

            cogoToast.success(i18n.t("added_to_cart"), { position: "bottom-left" });
        },
        deleteFromCart(state, action) {
            state.cartItems = state.cartItems.filter(item => item.cartItemId !== action.payload);
            cogoToast.error(i18n.t("removed_from_cart"), { position: "bottom-left" });
        },
        decreaseQuantity(state, action) {
            const product = action.payload;
            if (product.quantity === 1) {
                state.cartItems = state.cartItems.filter(item => item.cartItemId !== product.cartItemId);
                cogoToast.error(i18n.t("removed_from_cart"), { position: "bottom-left" });
            } else {
                state.cartItems = state.cartItems.map(item =>
                    item.cartItemId === product.cartItemId
                        ? { ...item, quantity: item.quantity - 1 }
                        : item
                );
                cogoToast.warn(i18n.t("quantity_decreased"), { position: "bottom-left" });
            }

            // Miktar değiştiğinde kuponu temizle (fiyatların güncellenmesi için)
            if (state.couponData) {
                state.couponData = null;
            }
        },
        increaseQuantity(state, action) {
            const product = action.payload;
            state.cartItems = state.cartItems.map(item =>
                item.cartItemId === product.cartItemId
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
            );
            cogoToast.success(i18n.t("quantity_increased"), { position: "bottom-left" });

            // Miktar değiştiğinde kuponu temizle (fiyatların güncellenmesi için)
            if (state.couponData) {
                state.couponData = null;
            }
        },
        deleteAllFromCart(state) {
            state.cartItems = []
        },
        setCouponData(state, action) {
            state.couponData = action.payload
        },
        clearCouponData(state) {
            state.couponData = null
        },
        setPendingCoupon(state, action) {
            state.pendingCoupon = action.payload;
        },
        clearPendingCoupon(state) {
            state.pendingCoupon = null;
        }
    },
});

export const { addToCart, deleteFromCart, decreaseQuantity, increaseQuantity, deleteAllFromCart, setCouponData, clearCouponData, setPendingCoupon, clearPendingCoupon } = cartSlice.actions;
export default cartSlice.reducer;
